import { render, staticRenderFns } from "./_promotions.vue?vue&type=template&id=6a0d55c8&scoped=true&"
import script from "./_promotions.vue?vue&type=script&lang=js&"
export * from "./_promotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0d55c8",
  null
  
)

export default component.exports